document.addEventListener('DOMContentLoaded', function() {

  const badgeButtons = document.querySelectorAll('.rating-badge-button');
  const revealArea = document.getElementById('ratingReviewReveal');

  if (!badgeButtons.length || !revealArea) return;

  // Patch the sticky scroll observer to ignore the review reveal height
  const stickyEl = document.querySelector('sticky-scroll-direction');
  if (stickyEl && stickyEl.stickyHeightElems) {

    function debounce(fn, wait) {
      let t;
      return function() { clearTimeout(t); t = setTimeout(fn, wait); };
    }

    const patched = function() {
      let totalHeight = 0;
      document.querySelectorAll(stickyEl.stickyHeightElems).forEach(elem => {
        totalHeight += elem.getBoundingClientRect().height;
      });
      const reveal = document.getElementById('ratingReviewReveal');
      if (reveal) totalHeight -= reveal.getBoundingClientRect().height;
      stickyEl.parentElement.style.setProperty('--sticky-height', `${parseInt(totalHeight, 10)}px`);
    };

    // Replace both the instance method and the debounced observer callback
    stickyEl.setStickyHeight = patched;
    const debouncedPatched = debounce(patched, 500);
    stickyEl.debouncedSetStickyHeights = debouncedPatched;

    // Re-register the MutationObserver with the patched debounced handler
    if (stickyEl.observer) stickyEl.observer.disconnect();
    stickyEl.observer = new MutationObserver(debouncedPatched);
    document.querySelectorAll(stickyEl.stickyHeightElems).forEach(elem => {
      stickyEl.observer.observe(elem, { childList: true, attributes: true, subtree: true });
    });
  }

  badgeButtons.forEach(button => {
    button.addEventListener('click', function() {

      const reviewId = this.getAttribute('data-review');
      const reviewContent = document.querySelector(`[data-review-content="${reviewId}"]`);
      const isActive = this.classList.contains('active');

      badgeButtons.forEach(btn => btn.classList.remove('active'));
      document.querySelectorAll('.review-content').forEach(content => {
        content.classList.remove('active');
      });

      if (isActive) {
        revealArea.classList.remove('active');
      } else {
        this.classList.add('active');
        reviewContent.classList.add('active');
        revealArea.classList.add('active');
      }

    });
  });

});